import {
  parseISO,
  isValid,
  differenceInYears,
  addMonths,
  endOfMonth,
} from 'date-fns';

export const calculateYears = (dateStr: string): number | null => {
  const parsed = parseISO(dateStr);
  if (!isValid(parsed)) return null;

  const endOfCurrentMonth = endOfMonth(new Date());
  const todayPlusTwoMonths = addMonths(endOfCurrentMonth, 2);

  return differenceInYears(todayPlusTwoMonths, parsed);
};
